const IconBusiness: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.5 19C1.1 19 0.75 18.85 0.45 18.55C0.15 18.25 0 17.9 0 17.5V5.275C0 4.875 0.15 4.525 0.45 4.225C0.75 3.925 1.1 3.775 1.5 3.775H6.25V1.5C6.25 1.1 6.4 0.75 6.7 0.45C7 0.15 7.35 0 7.75 0H12.25C12.65 0 13 0.15 13.3 0.45C13.6 0.75 13.75 1.1 13.75 1.5V3.775H18.5C18.9 3.775 19.25 3.925 19.55 4.225C19.85 4.525 20 4.875 20 5.275V17.5C20 17.9 19.85 18.25 19.55 18.55C19.25 18.85 18.9 19 18.5 19H1.5ZM7.75 3.775H12.25V1.5H7.75V3.775ZM18.5 12.725H12.275V14.225H7.775V12.725H1.5V17.5H18.5V12.725ZM9.275 12.725H10.775V11.225H9.275V12.725ZM1.5 11.225H7.775V9.725H12.275V11.225H18.5V5.275H1.5V11.225Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconBusiness;
